const state = {
  donutChart: {
    dataLabels: {
      enabled: false,
    },
    colors: ['#0CFB92', '#FFC100', '#FD0040'],
    title: {
      text: undefined,
      style: {
        fontSize: '30px',
        fontWeight: 'bold',
        fontFamily: 'Red Hat Text, sans-serif',
        color: '#263238',
      },
    },
    chart: {
      redrawOnParentResize: true,
    },
    legend: {
      show: true,
      fontSize: '16px',
      position: 'bottom',
      width: 'min-content',
      offsetX: -30,
      offsetY: 0,
      labels: {
        useSeriesColors: false,
      },
      markers: {
        size: 11,
        radius: 0,
      },
      itemMargin: {
        vertical: 2,
      },
    },
    plotOptions: {
      pie: {
        donut: {
          size: '70%',
        },
      },
    },
    tooltip: {
      fixed: {
        enabled: false,
      },
      shared: false,
      intersect: true,
      custom({ series, seriesIndex, w }) {
        return (
          `${'<div style="background-color: white; padding: 5px;">' +
            '<br/>' +
            `<span style="color: ${w.config.colors[seriesIndex]}; font-size: 16px; font-weight: bold;">`}${
            series[seriesIndex]
          }</span>` + '</div>'
        );
      },
    },
  },
  pieChart: {
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: true,
      fontSize: '16px',
      position: 'bottom',
      width: 'min-content',
      offsetX: -30,
      offsetY: 0,
      labels: {
        useSeriesColors: false,
      },
      markers: {
        size: 11,
        radius: 0,
      },
      itemMargin: {
        vertical: 2,
      },
    },
    title: {
      text: undefined,
      style: {
        fontSize: '30px',
        fontWeight: 'bold',
        fontFamily: 'Red Hat Text, sans-serif',
        color: '#263238',
      },
    },
    chart: {
      type: 'pie',
      redrawOnParentResize: true,
    },
    colors: ['#000000', '#0CFB92', '#8400ff', '#FFC100', '#3887B7', '#D4002A'],
    tooltip: {
      fixed: {
        enabled: true,
      },
      custom({ series, seriesIndex, w }) {
        return (
          `${'<div style="background-color: white; padding: 5px;">' +
            '<span style="color: black; font-size: 10px;">' +
            `${w.config.labels[seriesIndex]}` +
            '</span>' +
            '<br/>' +
            '<span style="color: black; font-size: 16px; font-weight: bold;">'}${
            series[seriesIndex]
          }</span>` + '</div>'
        );
      },
    },
  },
  lineChart: {
    chart: {
      type: 'area',
      offsetY: 10,
      zoom: {
        enabled: false,
      },
      redrawOnParentResize: true,
      redrawOnWindowResize: true,
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: 'smooth',
    },

    legend: {
      show: true,
      floating: true,
      fontSize: '16px',
      position: 'bottom',
      width: 'min-content',
      offsetX: -30,
      offsetY: 0,
      labels: {
        useSeriesColors: false,
      },
      markers: {
        size: 11,
        radius: 0,
      },
      formatter(seriesName) {
        return seriesName;
      },
      itemMargin: {
        vertical: 2,
      },
    },
    fill: {
      gradient: {
        inverseColors: false,
        shade: 'dark',
        type: 'vertical',
        opacityFrom: 0.85,
        opacityTo: 0.75,
        stops: [0, 100, 100, 100],
      },
    },
    tooltip: {
      custom({ series, seriesIndex, w, dataPointIndex }) {
        return (
          `${'<div style="background-color: white; padding: 5px;">' +
            '<span style="color: black; font-size: 10px;">' +
            `<span style="color: ${w.config.colors[seriesIndex]}; font-size: 16px; font-weight: bold;">`}${
            series[seriesIndex][dataPointIndex]
          }</span>` + '</div>'
        );
      },
    },
  },
  radialChart: {
    chart: {
      type: 'radialBar',
    },
    title: {
      text: undefined,
      style: {
        fontSize: '30px',
        fontWeight: 'bold',
        fontFamily: 'Red Hat Text, sans-serif',
        color: '#263238',
      },
    },
    plotOptions: {
      radialBar: {
        endAngle: 360,
        dataLabels: {
          name: {
            show: true,
          },
          value: {
            show: true,
          },
          total: {
            show: true,
            label: 'Total',
            formatter(w) {
              return w.config.series.reduce((a, b) => a + b, 0);
            },
          },
        },
      },
    },
    colors: ['#C21333', '#ADADAD'],
    legend: {
      show: true,
      floating: true,
      fontSize: '16px',
      position: 'bottom',
      width: 'min-content',
      offsetX: -30,
      offsetY: 0,
      labels: {
        useSeriesColors: false,
      },
      markers: {
        size: 11,
        radius: 0,
      },
      formatter(seriesName) {
        return seriesName;
      },
    },
  },
  gaugeChart: {
    chart: {
      type: 'radialBar',
      offsetY: -20,
      sparkline: {
        enabled: true,
      },
    },
    colors: ['#20E647'],
    plotOptions: {
      radialBar: {
        startAngle: -90,
        endAngle: 90,
        track: {
          background: '#e7e7e7',
          strokeWidth: '97%',
          margin: 5,
          dropShadow: {
            enabled: true,
            top: 2,
            left: 0,
            color: '#999',
            opacity: 1,
            blur: 2,
          },
        },
        dataLabels: {
          name: {
            show: false,
          },
          value: {
            offsetY: -2,
            fontSize: '22px',
          },
        },
      },
    },
    grid: {
      padding: {
        top: -10,
      },
    },
    title: {
      text: '',
    },
    fill: {
      type: 'gradient',
      gradient: {
        shade: 'light',
        shadeIntensity: 0.4,
        inverseColors: false,
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 50, 53, 91],
      },
    },
  },
  barChart: {
    chart: {
      type: 'bar',
      height: 350,
      redrawOnParentResize: true,
    },
    colors: [
      '#0CFB92',
      '#000000',
      '#0F84F1',
      '#D4002A',
      '#777777',
      '#87001B',
      '#FFC100',
    ],
    title: {
      text: '',
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
        distributed: true,
      },
    },
    yaxis: {
      title: {
        style: {
          color: 'grey',
        },
      },
    },
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
  },
};

// getters
const getters = {
  getDonutChart: vueState => vueState.donutChart,
  getLineChart: vueState => vueState.lineChart,
  getRadialChart: vueState => vueState.radialChart,
  getPieChart: vueState => vueState.pieChart,
  getGaugeChart: vueState => vueState.gaugeChart,
  getBarChart: vueState => vueState.barChart,
};

// actions
const actions = {};

// mutations
const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
